import React, { useRef, useState, useEffect } from "react";
import GASOLINEIMG from "../../../assets/png/1000_EFI _GASOLINE.png";
import { useNavigate } from "react-router-dom";
import ModelSlider from "../../allModels/modelSlider";

const ModelsInfo = () => {
  const [topPartHeight, setTopPartHeight] = useState(0);

  const topPartRef = useRef(null);

  useEffect(() => {
    // Measure the height of the Top Part once it has been rendered
    if (topPartRef.current) {
      setTopPartHeight(topPartRef.current.offsetHeight);
    }
  }, []);

  return (
    <div className="relative custom-container">
      <div
        ref={topPartRef}
        className="top-[-110px] bg-[#7ABF5B] absolute pt-[46px] pb-[60px] px-[10px] sm:px-[40px] lg:px-[99px] mx-[0px] sm:mx-[50px] lg:mx-[116px]"
        style={{
          boxShadow: "0px 4px 4px 0px #00000040",
        }}
      >
        <div className="font-[Rockwell] text-black font-bold 2xl:text-[40px] xl:text-[35px] lg:text-[30px] md:text-[25px] sm:text-[20px] text-[17px] text-center">
          ALL STEEL UTILITY VEHICLE
        </div>
        <div className="flex items-center justify-center mb-[20px] mt-[5px]">
          <div className="bg-[#fff] sm:h-[8px] h-[5px] sm:w-[350px] w-[150px]"></div>
        </div>
        <div
          className="font-[Roboto] text-black font-bold
        2xl:text-[30px] xl:text-[25px] lg:text-[23px] sm:text-[20px] text-[16px]
         text-center"
        >
          Experience the difference with Tuatara—the utility vehicle built to evolve and excel. Explore our range of
          models and discover why Tuatara is the go-to choice for those who demand performance, reliability, and
          sustainability.
        </div>
      </div>
      <div style={{ paddingTop: `${topPartHeight - 53}px` }}>
        <div className="text-center lg:pb-[56px] sm:pb-[46px] pb-[26px]">
          <div className="text-[#292929] font-[Rockwell] font-extrabold 2xl:text-[35px] xl:text-[30px] lg:text-[25px] md:text-[20px] text-[17px]">
            EXPLORE ALL MODELS
          </div>
        </div>

        <ModelSlider />
      </div>
    </div>
  );
};

export default ModelsInfo;
